"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layers = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const node_1 = require("../common/node");
const props_1 = require("../common/props");
/**
 * Accessibility layers.
 * @category Layers
 */
class Layers extends node_1.Node {
    constructor(parent) {
        super("layers", parent);
        this.colorBlind = new props_1.PropertyBoolean("Color Blind", false, this, { defaultValue: false });
        this.dyslexia = new props_1.PropertyBoolean("Dyslexia", false, this, { defaultValue: false });
        this.motionSensitivity = new props_1.PropertyBoolean("Motion Sensitivity", false, this, { defaultValue: false });
        this.properties = [this.colorBlind, this.dyslexia, this.motionSensitivity];
        this.deviceTarget = new props_1.PropertyStringSelectable("Devices", true, this, {
            selectables: [Layers.DT_DESKTOP, Layers.DT_TABLET, Layers.DT_MOBILE],
            defaultValue: Layers.DT_DESKTOP,
        });
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.colorBlind.deserialize(obj.colorBlind);
        this.dyslexia.deserialize(obj.dyslexia);
        this.motionSensitivity.deserialize(obj.motionSensitivity);
        this.deviceTarget.deserialize(obj.deviceTarget);
    }
    serialize() {
        const obj = {};
        obj.colorBlind = this.colorBlind.serialize();
        obj.dyslexia = this.dyslexia.serialize();
        obj.motionSensitivity = this.motionSensitivity.serialize();
        obj.deviceTarget = this.deviceTarget.serialize();
        return obj;
    }
}
exports.Layers = Layers;
Layers.DT_DESKTOP = "desktop";
Layers.DT_TABLET = "tablet";
Layers.DT_MOBILE = "mobile";
